import { html, LitEntity } from '../../utility/lit-entity';
import './microsoft-finance-and-operations-integration-modal';
import { IntegrationOverviewMixin } from './integration-overview-mixin';

class MicrosoftFinanceAndOperationsIntegrationOverview extends IntegrationOverviewMixin(LitEntity) {
  render() {
    return this.renderOverview();
  }

  renderModal() {
    return html`
      <microsoft-finance-and-operations-integration-modal
        title="${this.title}"
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></microsoft-finance-and-operations-integration-modal>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.integrationEnabled = this.entity.properties.credentialsConfigured;
  }
}

window.customElements.define('microsoft-finance-and-operations-integration-overview', MicrosoftFinanceAndOperationsIntegrationOverview);
